import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconArrowLeftBlack = props => {
  if (props.id !== "_svgiconarrowleftblack") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fill="#202020" fillRule="evenodd" d="M15.082 9.962l-8.797 8.373c-.997.95-.997 2.38 0 3.33l8.797 8.373c.432.411 1.176.447 1.66.08.484-.369.526-1 .093-1.412l-8.096-7.707h24.548c.65.001 1.176-.446 1.176-.999s-.526-1-1.176-1H8.74l8.096-7.706a.916.916 0 00.3-.665.938.938 0 00-.393-.746c-.484-.368-1.227-.332-1.66.08z" /></svg>;
};

SvgIconArrowLeftBlack.displayName = "_svgiconarrowleftblack";
SvgIconArrowLeftBlack.propTypes = {
  id: PropTypes.string
};
SvgIconArrowLeftBlack.defaultProps = {
  id: ''
};
export default SvgIconArrowLeftBlack;